export default __webpack_public_path__ + "38f8ef918b3e115eb9a514fee06bdbc7.jpg";